import { Hidden, Stack } from 'braid-design-system';
import HoustonAd from '../HoustonAd/HoustonAd';
import SaveSearch from '../SaveSearch/SaveSearch';
import useSideBar from './useSideBar';
import { SearchResultsHeaderSpacer } from '../SearchResultHeaders/SearchResultsHeaders';

const SideBar = () => {
  const { authenticated, saveable, country, retireDisplayAds } = useSideBar();

  return (
    <Hidden below="tablet">
      <SearchResultsHeaderSpacer />
      <Stack space="medium">
        {saveable && authenticated ? <SaveSearch /> : null}
        {retireDisplayAds ? null : (
          <HoustonAd
            tagId={`/23030987465/SEEK${country}/jobsearch_skyscraper`}
            width={160}
            height={600}
            minWidth={740}
          />
        )}
      </Stack>
    </Hidden>
  );
};

export default SideBar;
